// extracted by mini-css-extract-plugin
export var section = "section-module--section--b6faa";
export var wrapper = "section-module--wrapper--f99ff";